import React from 'react';

export default React.createContext({});

const getSecurityHeaders = context => {
  return { 'x-access-token': context.id_token };
};

export { getSecurityHeaders };
